import createReactClass from 'create-react-class';
import './UserRatingButton.css';
import './UserRatingNegativeReasonButton.css';
import myAjax from '../global/libs/myAjax.js';
import PropTypes from 'prop-types';

const RATING_REASON_OTHER_LABEL_FOR_DISP = 'その他';
const RATING_REASON_OTHER_LABEL = '自由記述';
const RATING_REASON_OTHER_VALUE = 10;
const RATING_REASON_INITIAL_VALUE = 0;
export const RATING_REASON_INITIAL_LABEL = '-';

let UserRatingNegativeReasonButton = createReactClass({
  propTypes: {
    ratingReasons: PropTypes.array,
    ratingReasonMsg: PropTypes.string,
    logId: PropTypes.number,
    logUrl: PropTypes.string
  },

  getInitialState: function () {
    let button_labels = this.props.ratingReasons.concat();
    button_labels.sort(function (a, b) {
      if (a.name > b.name) {
        return 1;
      } else {
        return -1;
      }
    });
    let ratingReasons = [];
    for (let i = 0; i < button_labels.length; i++) {
      let name = button_labels[i].name;
      let val = button_labels[i].value;
      let reason_id_str = name.substr(-1);
      if (val && !isNaN(reason_id_str)) {
        let reason_id = parseInt(reason_id_str, 10);
        ratingReasons.push({value: reason_id, name: val, checked: false});
      }
    }
    if (ratingReasons.length > 0) {
      ratingReasons.push({
        value: RATING_REASON_OTHER_VALUE,
        name: RATING_REASON_OTHER_LABEL_FOR_DISP,
        checked: false
      });
    }
    let logId = this.props.logId;
    const logUrl =
      this.props.logUrl === undefined || this.props.logUrl.length === 0 ? '/api/logging/core/' : this.props.logUrl;

    return {
      btnInitial: 'btn-rating-initial btn-rating',
      btnClicked: 'btn-rating-clicked btn-rating',
      ratingReasonMsg: this.props.ratingReasonMsg,
      reasons: ratingReasons,
      selectedId: RATING_REASON_INITIAL_VALUE,
      selectedText: RATING_REASON_INITIAL_LABEL,
      inputText: '',
      logId: logId,
      logUrl: logUrl,
      hasRatingFinished: false
    };
  },

  onClick() {
    let sendId = this.state.selectedId;
    let sendText = this.state.selectedText;
    let sendTextFree = '';
    if (sendId === RATING_REASON_INITIAL_VALUE) {
      return;
    } else if (sendId === RATING_REASON_OTHER_VALUE) {
      sendText = RATING_REASON_OTHER_LABEL;
      sendTextFree = this.state.inputText;
      if (!sendTextFree) {
        return;
      }
    }
    this.setState({hasRatingFinished: false});

    let logId = this.props.logId;
    const logUrl = this.state.logUrl;
    myAjax(
      logUrl + logId,
      {
        negative_rating_reason: sendText,
        negative_rating_reason_free: sendTextFree
      },
      'PATCH'
    ).done(
      function () {
        this.setState({hasRatingFinished: true});
      }.bind(this)
    );
  },

  handleChangeFreeText(event) {
    const MAX_LENGTH = 1000;
    const inputText = event.target.value;
    if (inputText.length > MAX_LENGTH) {
      return;
    }
    let reasons = this.state.reasons.map((item) => {
      return {
        value: item.value,
        name: item.name,
        checked: item.value === RATING_REASON_OTHER_VALUE ? true : false
      };
    });
    this.setState({
      reasons: reasons,
      selectedId: RATING_REASON_OTHER_VALUE,
      selectedText: RATING_REASON_OTHER_LABEL_FOR_DISP,
      inputText: inputText
    });
  },

  handleRadioClick(e) {
    let val = parseInt(e.target.value, 10);
    let reasons = this.state.reasons.map((item) => {
      return {
        value: item.value,
        name: item.name,
        checked: item.value === val ? true : false
      };
    });
    let inputText = this.state.inputText;
    if (val !== RATING_REASON_OTHER_VALUE) {
      inputText = '';
    }
    this.setState({
      reasons: reasons,
      selectedId: val,
      selectedText: e.target.name,
      inputText: inputText
    });
  },

  UNSAFE_componentWillUpdate() {},

  render() {
    if (this.state.logId !== this.props.logId) {
      this.setState(this.getInitialState());
    }

    const reasons = this.state.reasons;
    const listItems = reasons.map((r) => (
      <label className="check_lb" key={r.name}>
        <input type="radio" name={r.name} value={r.value} checked={r.checked} onChange={this.handleRadioClick} />
        {r.name}
        <br />
      </label>
    ));

    const showAddtionalMessage = Boolean(!this.state.logUrl.includes('/api/logging/shareqa'));
    const userRatingThanksMsg = (
      <div>
        ご協力ありがとうございました。
        {showAddtionalMessage ? (
          <>
            <br />
            <span>最初から質問する場合は、右上のホームアイコンを押してください。</span>
          </>
        ) : null}
      </div>
    );

    return (
      <table className="tbl-layout">
        <tbody>
          <tr>
            <td id="user-rating-reason-ask-message" className="user-rating-ask-msg">
              {this.state.ratingReasonMsg}
            </td>
          </tr>
          <tr>
            {this.state.hasRatingFinished ? (
              <td id="user-rating-reason-message" className="user-rating-msg user-rating-msg-clicked">
                {userRatingThanksMsg}
              </td>
            ) : (
              <td id="user-rating-reason-message" className="user-rating-msg user-rating-msg-initial"></td>
            )}
          </tr>
          <tr>
            <td>
              <form>{listItems}</form>
              <input
                id="free_text_input"
                type="text"
                name="negative_rating_reason"
                value={this.state.inputText}
                onChange={this.handleChangeFreeText}
              />
              <div className="btn-inquiry-layout">
                <button id="submit" className={this.state.btnInitial} onClick={this.onClick}>
                  送信
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
});

export default UserRatingNegativeReasonButton;
